import { Index } from "lunr";
import React from "react";

interface StoredSearchIndex {
  index: Index;
  refs: {};
}

type SetIndexFn = (key: string, value: StoredSearchIndex) => void;

type SearchContext = {
  indexes: Record<string, StoredSearchIndex>;
  setIndex: SetIndexFn;
};

export const SearchContext = React.createContext<SearchContext>({
  indexes: {},
  setIndex: () => {},
});

export const SearchContextProvider: React.FC = ({ children }) => {
  const [indexes, setIndexes] = React.useState<
    Record<string, StoredSearchIndex>
  >({});

  const setIndex = React.useCallback(
    (key: string, value: StoredSearchIndex) => {
      setIndexes(s => ({
        ...s,
        [key]: value,
      }));
    },
    []
  );

  return (
    <SearchContext.Provider
      value={{
        indexes,
        setIndex,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};
